<template>
  <fin-header-footer-container :vertical-centered="contentVerticalCentered" footer-color="#edf1f4" header-color="#fff">
    <template #header>
      <fin-registration-header/>
    </template>

    <template #default="{ footerHeight }">
      <v-row justify="center" no-gutters>
        <v-col :style="`max-width: ${containerMaxWidth}; z-index: 10;`" cols="12">
          <h1 id="onbRegStart" style="text-align: center">Los geht’s!</h1>
          <p class="mt-4" style="text-align: center">Erstelle dir jetzt deinen persönlichen finAccount.<br>
            Zuallererst benötigen wir ein paar Informationen von dir:</p>

          <v-form id="signUpForm" ref="form" v-model="form.valid" @submit.prevent="">
            <v-row class="mt-8">
              <v-col class="py-0" cols="12" sm="6" style="min-height: 90px">
                <fin-email-input id="mail"
                                 :disabled="disabled"
                                 background-color="white"
                                 v-model="form.email"
                                 :errorMessages="errorEmail"
                                 validate-on-blur
                                 @input="resetErrors"/>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" style="min-height: 90px">
                <fin-password-input id="pwd"
                                    :min-length="8"
                                    background-color="white"
                                    v-model="form.password"
                                    :disabled="disabled"
                                    update
                                    :errorMessages="errorPwd"
                                    :password-policy="passwordPolicy"
                                    label="Dein Passwort"
                                    show-password-policy
                                    validate-on-blur
                                    @input="resetErrors"/>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" style="min-height: 90px">
                <v-text-field id="nickname-input"
                              v-model="form.username"
                              :disabled="disabled"
                              :rules="[ v => !!v || 'Bitte gebe deinen Benutzernamen ein' ]"
                              background-color="white"
                              outlined
                              label="Dein Benutzername"
                              placeholder="Wie dürfen wir dich nennen?"
                              @input="resetErrors"/>
              </v-col>
              <v-col :style="$vuetify.breakpoint.smAndUp ? 'min-height: 90px' : ''"
                     class="py-0 d-flex d-inline-block align-center" cols="12"
                     sm="6">
                <fin-country-selector v-model="form.country"
                                      class="mb-2 mb-sm-8"
                                      label="Wohnsitz"/>
              </v-col>
              <v-col class="pb-0" cols="12">
                <fin-data-loader :resolver="fetchData">
                  <fin-social-media-sign-in v-if="isSocialMediaAppleActive || isSocialMediaGoogleActive"
                                            :isSocialMediaAppleActive="isSocialMediaAppleActive"
                                            :isSocialMediaGoogleActive="isSocialMediaGoogleActive"
                                            @socialLoginInProgress="socialLoginInProgress = true">
                  </fin-social-media-sign-in>
                </fin-data-loader>
              </v-col>
              <v-col class="pb-0" cols="12">
                <v-checkbox v-if="false"
                            id="onb-reg-newsletter-chk"
                            v-model="form.newsletterRegistration"
                            class="pt-0 mt-0"
                            style="float: left; margin-right: 10px;">
                  <template #label>
                      <span style="color: #000;">
                        Anmeldung zum Newsletter (diese Einstellung kann unter "Profil verwalten" jederzeit angepasst werden)
                      </span>
                  </template>
                </v-checkbox>
                <v-checkbox id="onb-reg-termsofuse-chk"
                            :rules="checkboxRequiredRule"
                            class="pt-0 mt-0"
                            style="float: left; margin-right: 10px;"
                            v-model="form.acceptDataSafety"
                            @change="resetErrors">
                  <template #label>
                      <span style="color: #000; hyphens: none">
                        <span @click.capture.stop.prevent="dataSafetyDialog = true"
                              style="text-decoration: underline; cursor: pointer;">Datenschutzerklärung</span>
                        <span @click.capture.stop.prevent="() => {}">
                          &nbsp;zur Kenntnis genommen
                        </span>
                      </span>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col class="d-flex justify-center pa-0" cols="12">
                <v-btn id="signUpBtn"
                       :color="$finColors.primaryDark"
                       :disabled="disableSubmitBtn"
                       :loading="loading"
                       :width="120"
                       class="my-2"
                       style="border-radius: 0; z-index: 2;"
                       type="submit"
                       @click='submitRegistration'>
                  <span class="start-button-text pl-2 pr-2" style="color:white">Jetzt senden</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row :style="`maxWidth: ${containerMaxWidth}; padding-bottom: ${footerHeight}px;`"
                   class="bfvtext-wrapper">
              <v-col>
                <p :class="`bfVText ${!readMoreActivated ? 'short' : ''}`"
                   v-html="bfVText">
                </p>
                <v-btn class="bfVBtn" icon small @click="readMoreActivated = !readMoreActivated">
                  <v-icon v-if="!readMoreActivated">icon-arrow-down</v-icon>
                  <v-icon v-if="readMoreActivated">icon-arrow-up</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

        </v-col>
      </v-row>

      <v-row v-if="errorOther">
        <v-col cols="12">
          <fin-error-msg :msg="errorOther"/>
        </v-col>
      </v-row>

      <v-img :src="require('@/assets/registration/registration-background.svg')"
             :style="{
                maxHeight: '100%',
                backgroundColor: 'white',
                position: 'fixed',
                bottom: footerHeight + 'px',
                width: '100%',
                left: 0,
                opacity: $vuetify.breakpoint.smAndDown ? 0.4 : 1,
             }"
             contain
      />

      <fin-dialog v-model="dataSafetyDialog" dense>
        <fin-data-protection is-dialog/>
      </fin-dialog>
    </template>

    <template #footer>
      <fin-registration-footer id="fin-already-registered"/>
    </template>
  </fin-header-footer-container>
</template>

<script>
import FinRegistrationFooter from '@/components/pages/onboarding/Step1/RegistrationFooter'
import FinRegistrationHeader from '@/components/pages/onboarding/Step1/RegistrationHeader'
import FinPwdPolicy from '@/js/finPwdPolicy'
import FinHeaderFooterContainer from '@/components/common/HeaderFooterContainer/index'
import FinEmailInput from '@/components/common/form/EmailInput'
import FinPasswordInput from '@/components/common/form/PasswordInput/index'
import FinDataProtection from '@/views/public/finDataProtection'
import {ERROR_TYPE, handleError} from '@/js/errorhandler/finAWSErrorHandler'
import FinCountrySelector from "@/components/common/CountrySelector"
import FinErrorMsg from "@/components/common/ErrorMsg"
import AmplitudePush from "@/mixins/AmplitudePush"
import {API} from "@/plugins/finAmplifyModules"
import {registerUser} from "@/js/finMutations"
import FinDataLoader from "@/components/common/DataLoader"
import FinSocialMediaSignIn from "@/components/auth/SocialMediaSignIn"
import {getSystemStatus} from "@/js/finQueries"
import {mapGetters} from "vuex"

export default {
  name: 'fin-registration',
  components: {
    FinSocialMediaSignIn,
    FinDataLoader,
    FinErrorMsg,
    FinCountrySelector,
    FinDataProtection,
    FinPasswordInput,
    FinEmailInput,
    FinHeaderFooterContainer,
    FinRegistrationHeader,
    FinRegistrationFooter
  },
  props: {
    activeStep: {
      type: Number
    }
  },
  data() {
    return {
      readMoreActivated: false,
      bfVText: "Die finCraft AG ist im Rahmen der Anlageberatung und Anlagevermittlung von Finanzinstrumenten gem. §2 Abs. 2 Nr. 3,4 WpIG ausschließlich für Rechnung und unter der Haftung der BfV Bank für Vermögen AG tätig. Abweichend hiervon findet die Erstellung des Anlagevorschlages nicht unter dem Haftungsdach der BfV AG statt wenn der Anwender/Kunde auf die Nutzung seines von finCraft erhobenen Archetypen  (Investorprofil) als Ausgangsbasis seines Investmentprozesses verzichtet. In deinem persönlichen Profilbereich (Dein Menü >> Profil verwalten) haben wir dir wichtige Unterlagen und weiterführende Informationen zur BfV zur Verfügung gestellt.",
      loading: false,
      errorPwd: '',
      errorEmail: '',
      errorOther: '',
      form: {
        valid: false,
        username: this.$route.query.email ? this.$route.query.email.substring(0, this.$route.query.email.indexOf('@')) : '',
        email: this.$route.query.email ? this.$route.query.email : '',
        password: '',
        newsletterRegistration: true,
        country: {id: 'DE'}
      },
      checkboxRequiredRule: [
        v => v === true || 'Akzeptiere bitte die Datenschutzerklärung'
      ],
      disabled: process.env.VUE_APP_ALLOW_SIGN_UP !== 'true',
      passwordPolicy: FinPwdPolicy.policy,
      dataSafetyDialog: false,
      acceptDataSafety: false,
      isSocialMediaAppleActive: false,
      isSocialMediaGoogleActive: false,
      socialLoginInProgress: false
    }
  },
  computed: {
    ...mapGetters('auth', ['publicQueryAuthMode']),
    contentVerticalCentered() {
      return (this.$vuetify.breakpoint.xs && window.innerHeight > 800) ||
        (this.$vuetify.breakpoint.smAndUp && window.innerHeight > 600)
    },
    containerMaxWidth() {
      return this.$vuetify.breakpoint.xs ? "100%" : '566px'
    },
    disableSubmitBtn() {
      return this.disabled || !this.form.valid
    },
  },
  mixins: [AmplitudePush],
  methods: {
    async fetchData() {
      if (this.$route.query.socialMediaTest === "yes") {
        this.isSocialMediaAppleActive = true
        this.isSocialMediaGoogleActive = true
      } else {
        this.isSocialMediaAppleActive = await this.getSystemStatus("FINCRAFT_APPLE_SIGN_IN")
        //console.log("fetch FINCRAFT_APPLE_SIGN_IN", this.isSocialMediaAppleActive)
        this.isSocialMediaGoogleActive = await this.getSystemStatus("FINCRAFT_GOOGLE_SIGN_IN")
        //console.log("fetch FINCRAFT_GOOGLE_SIGN_IN", this.isSocialMediaGoogleActive)
      }
    },
    async getSystemStatus(id) {
      try {
        const options = {
          query: getSystemStatus,
          variables: {
            id: id
          },
          authMode: this.publicQueryAuthMode
        }
        console.log("options", options)
        const result = await API.graphql(options)
        return result.data.getSystemStatus.status === "TRUE"
      } catch (error) {
        console.error("getSystemStatus failed", error)
        return false
      }
    },
    trackToAmplitude(action, cause) {
      this.pushToAmplitude({
        'event': 'fincraft_registration_' + action,
        'step': action,
        'step_choice': cause,
        'placement': 'registration',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    resetErrors() {
      this.errorEmail = ''
      this.errorPwd = ''
      this.errorOther = ''

      // check form validity
      if (this.$refs.form && this.form.acceptDataSafety) {
        this.$refs.form.validate()
      }
    },
    submitRegistration() {
      if (this.disabled) {
        // should not happen, but protect this case
        console.log('should not happen, but just in case..., disabled:', this.disabled)
        return
      }

      if (!this.form.valid && !this.form.country.length > 0) {
        return
      }

      this.loading = true
      const {email, password, username, country} = this.form
      const onboarding = sessionStorage.getItem('onboarding')

      const signUpObject = {
        username: email.trim(),
        password: password.trim(),
        attributes: {
          email: email.trim(),
          address: JSON.stringify({country: country.id}),
          'custom:profileName': username,
          'custom:onboarding': onboarding
        },
        clientMetadata: {
          preferredLang: 'de_DE',
          signUpHost: window.location.origin
        }
      }

      this.$Amplify.Auth.signUp(signUpObject).then(() => {
        this.loading = false
        this.errorPwd = ''
        this.errorEmail = ''
        sessionStorage.removeItem('onboarding')
        this.$router.push({path: 'verify', query: {mail: this.form.email}})
        this.trackToAmplitude('signUp_success', '')
      }).catch(this.setError)
    },
    setError(e) {
      this.loading = false

      const error = handleError(ERROR_TYPE.SIGNUP, e)

      if (error.exception.includes('UsernameExistsException')) {
        this.errorEmail = error.msg
      } else if (error.exception === 'InvalidPasswordException') {
        this.errorPwd = error.msg
      } else {
        this.errorOther = error.msg
      }

      this.trackToAmplitude('signUp_failed', error.exception)
      console.error('Step1 Registration', e, error.msg)
    },
    async registerUser(email) {
      try {
        await API.graphql({
          query: registerUser,
          variables: {
            email: email
          },
          authMode: 'AWS_IAM'
        })
      } catch (error) {
        console.error("registerUser failed", error)
      }
    }
  },
  async mounted() {
    // insert in RegisterUser table
    const regExpEmailCheck = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}')
    if (this.form.email && this.form.email.trim() !== '' && regExpEmailCheck.test(this.form.email)) {
      await this.registerUser(this.form.email)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../../../styles/variables.scss";

.bfvtext-wrapper {
  position: absolute;
}

.bfVText {
  text-align: justify;
  font-size: 12px;
  color: $fin-color-cool-grey;
  margin-right: 20px;

  &.short {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.bfVBtn {
  position: absolute;
  top: 5px;
  right: 5px;
}

</style>
